import { ApprovalMailScheduleForm } from "./ApprovalMailScheduleForm";
import { useApprovalMailSchedule } from "./useApprovalMailSchedule";

export function ApprovalMailSchedulePanel() {
  const { settings, phase, message, saved, load, save } = useApprovalMailSchedule();
  return <section className="shift-admin-section shift-mail-schedule" aria-label="Günlük onay e-postası">
    {phase === "loading" ? <p role="status">Gönderim saati yükleniyor…</p> : null}
    {settings && phase !== "loading" ? <ApprovalMailScheduleForm key={settings.version} settings={settings} busy={phase === "saving"} onSave={save} /> : null}
    {saved ? <p role="status">Gönderim saati kaydedildi.</p> : null}
    {message ? <p role="alert">{message} <button type="button" onClick={() => void load()}>Güncel saati yükle</button></p> : null}
  </section>;
}
